import { UITextView } from "uicore-ts"


export interface RHEuroFormatOptions {
    currency?: string
    minimumFractionDigits?: number
    maximumFractionDigits?: number
}

export class RHEuroFormatter {

    static readonly locale = "et-EE"
    static readonly thousandsSeparator = "\u00A0"
    private static readonly _currencyFormatters = new Map<string, Intl.NumberFormat>()

    static currencyFormatter(options: RHEuroFormatOptions = {}): Intl.NumberFormat {
        const currency = options.currency ?? "EUR"
        const minimumFractionDigits = options.minimumFractionDigits ??
                                      (options.maximumFractionDigits === 0 ? 0 : undefined)
        const maximumFractionDigits = options.maximumFractionDigits
        const key = [
            currency,
            minimumFractionDigits ?? "",
            maximumFractionDigits ?? ""
        ].join("|")

        let formatter = RHEuroFormatter._currencyFormatters.get(key)
        if (!formatter) {
            const formatOptions: Intl.NumberFormatOptions = {
                style: "currency",
                currency
            }
            if (minimumFractionDigits !== undefined) {
                formatOptions.minimumFractionDigits = minimumFractionDigits
            }
            if (maximumFractionDigits !== undefined) {
                formatOptions.maximumFractionDigits = maximumFractionDigits
            }
            formatter = new Intl.NumberFormat(RHEuroFormatter.locale, formatOptions)
            RHEuroFormatter._currencyFormatters.set(key, formatter)
        }
        return formatter
    }

    static formattedCurrency(amount: number, options: RHEuroFormatOptions = {}): string {
        return RHEuroFormatter.currencyFormatter(options).format(amount)
    }

    static formattedNumber(amount: number): string {
        return UITextView.applyThousandsSeparatorToNumericalString(
            amount.toString(),
            RHEuroFormatter.thousandsSeparator
        )
    }
    
    static formattedAmount(amount: number): string {
        return RHEuroFormatter.formattedCurrency(amount, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })
    }
    
    static formattedAmountOrDash(amount: number | null | undefined): string {
        if (amount === null || amount === undefined || !Number.isFinite(amount)) {
            return "-"
        }
        return RHEuroFormatter.formattedAmount(amount)
    }
    
    static formattedAmountText(amountText: string): string {
        const cleanedAmountText = amountText.trim().replace(/\s/g, "")
        if (cleanedAmountText.length === 0) {
            return "-"
        }
        
        const usesCommaDecimalSeparator = cleanedAmountText.includes(",")
        const normalizedAmountText = cleanedAmountText.replace(",", ".")
        const formattedAmountText = UITextView.applyThousandsSeparatorToNumericalString(
            normalizedAmountText,
            RHEuroFormatter.thousandsSeparator
        )
        
        if (usesCommaDecimalSeparator) {
            return `${formattedAmountText.replace(".", ",")} €`
        }
        return `${formattedAmountText} €`
    }
    
}
